<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        class="inserirColabButton"
        @click="dialog = true"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="mr-2" color="primary">mdi-plus</v-icon>
        <span class="inserirColabButton__label">Nova colaboração</span>
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-message-plus-outline</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar colaboração</span>
          <span class="sc-modal__subtitle">Insira uma colaboração avulsa na produção</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <!-- Avatar + Nome -->
        <div class="avatar-row">
          <div class="avatar-wrapper" @click="triggerAvatarUpload">
            <template v-if="flg_sem_avatar === false">
              <v-img :src="url_avatar" class="avatar-img" />
              <v-btn
                v-if="avatar_file"
                icon x-small
                class="avatar-remove-btn"
                @click.stop="limparAvatarImagem"
              >
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <div class="avatar-placeholder">
                <FakeAvatar class="fake-avatar-svg" />
              </div>
              <div class="avatar-edit-badge">
                <v-icon x-small color="black">mdi-pencil</v-icon>
              </div>
            </template>
            <input
              ref="avatarInput"
              type="file"
              accept="image/png, image/jpeg, image/gif, image/jpg, image/tiff"
              style="display: none"
              @change="onAvatarInputChange"
            />
          </div>
          <div class="sc-modal__field" style="flex: 1">
            <label class="sc-modal__field-label">Nome</label>
            <v-text-field
              solo flat dense
              hide-details="auto"
              placeholder="Nome do colaborador..."
              v-model="dsc_nome_colaborador"
              background-color="surface_tertiary"
            />
          </div>
        </div>

        <!-- Complemento (Socialcam only) -->
        <div v-if="dsc_fonte_colaboracao === 'Socialcam'" class="sc-modal__field">
          <label class="sc-modal__field-label">Complemento</label>
          <v-text-field
            solo flat dense
            hide-details="auto"
            placeholder="Complemento..."
            v-model="dsc_complemento"
            background-color="surface_tertiary"
          />
        </div>

        <!-- Texto -->
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Texto</label>
          <v-textarea
            ref="textareaRef"
            solo flat dense
            hide-details="auto"
            no-resize
            placeholder="Texto da colaboração..."
            rows="3"
            v-model="dsc_texto_colaboracao"
            background-color="surface_tertiary"
            @input="updateScrollbarSize"
          />
          <span class="char-counter">{{ dsc_texto_colaboracao.trim().length }}</span>
        </div>

        <!-- Twitter warning -->
        <div
          v-if="dsc_texto_colaboracao && dsc_texto_colaboracao.trim().length > 280 && dsc_fonte_colaboracao === 'Twitter'"
          class="twitter-warning"
        >
          <v-icon small color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
          <span>Tweet muito longo para a tarja (máx. 280 caracteres)</span>
        </div>

        <!-- Rede social -->
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Rede social</label>
          <v-select
            dense solo flat
            v-model="dsc_fonte_colaboracao"
            :items="redes_sociais"
            hide-details="auto"
            placeholder="Escolha a rede social"
            background-color="surface_tertiary"
          />
        </div>

        <!-- WhatsApp phone -->
        <div v-if="dsc_fonte_colaboracao === 'Whatsapp'" class="sc-modal__field">
          <label class="sc-modal__field-label">Telefone</label>
          <v-text-field
            solo flat dense
            hide-details="auto"
            placeholder="Número do colaborador..."
            v-model="dsc_colaborador_phone"
            background-color="surface_tertiary"
          />
        </div>

        <!-- Social account + verified -->
        <div
          v-if="['Twitter', 'Threads', 'TikTok', 'Instagram'].includes(dsc_fonte_colaboracao)"
          class="social-account-row"
        >
          <div class="sc-modal__field" style="flex: 1">
            <label class="sc-modal__field-label">Conta</label>
            <v-text-field
              solo flat dense
              hide-details="auto"
              :placeholder="`@usuario (${dsc_fonte_colaboracao})`"
              v-model="dsc_conta_colaborador"
              background-color="surface_tertiary"
            />
          </div>
          <v-checkbox
            v-model="isColaboradorVerificado"
            label="Verificado"
            hide-details
            dense
            class="mt-0 pt-0 ml-3"
          />
        </div>

        <!-- Moderar toggle -->
        <div class="moderar-row">
          <span class="moderar-label">Moderar colaboração</span>
          <v-switch
            flat dense
            hide-details
            v-model="moderarColaboracao"
            color="primary"
            class="mt-0 pt-0"
          />
        </div>

        <!-- Coluna select -->
        <div v-if="moderarColaboracao" class="sc-modal__field">
          <label class="sc-modal__field-label">Coluna</label>
          <v-select
            dense solo flat
            v-model="colunaModerada"
            item-text="dsc_coluna"
            item-value="num_coluna_telao"
            return-object
            :items="colunas"
            hide-details="auto"
            placeholder="Escolha a coluna..."
            background-color="surface_tertiary"
          />
        </div>

        <!-- Mídia -->
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">
            {{ dsc_fonte_colaboracao === 'Twitter' ? 'Mídia do tweet' : 'Imagem, vídeo ou áudio' }}
          </label>
          <div class="media-area">
            <div v-if="!selectedMidia" class="media-dropzone" @click="$refs.mediaFileInput.click()">
              <v-icon color="text_secondary" class="media-icon">mdi-image-plus</v-icon>
              <span class="media-hint">Clique para adicionar</span>
              <input
                ref="mediaFileInput"
                type="file"
                :accept="media_types"
                style="display: none"
                @change="onFileSelected"
              />
            </div>
            <template v-if="image_or_video_file !== null">
              <div class="media-preview">
                <v-btn
                  v-if="!image_or_video_type.includes('audio')"
                  icon x-small
                  class="media-remove-btn"
                  @click.prevent="limparInputImagem"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
                <template v-if="image_or_video_type.includes('video')">
                  <video
                    width="100%"
                    height="150"
                    controls
                    v-if="url_image_or_video !== null"
                    :key="url_image_or_video"
                    style="border-radius: var(--sc-radius-md)"
                  >
                    <source :src="url_image_or_video" type="video/mp4" />
                  </video>
                </template>
                <template v-else-if="image_or_video_type.includes('image')">
                  <img
                    v-if="url_image_or_video !== null"
                    :src="url_image_or_video"
                    alt="Imagem"
                    class="media-img"
                  />
                </template>
                <template v-else-if="image_or_video_type.includes('audio')">
                  <div class="audio-file">
                    <v-icon small class="mr-2">mdi-music-note</v-icon>
                    <span>{{ image_or_video_file.name }}</span>
                    <v-btn icon x-small class="ml-auto" @click.prevent="limparInputImagem">
                      <v-icon x-small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text class="modal-btn-cancel" @click="close">Cancelar</v-btn>
        <v-btn color="primary" class="modal-btn-confirm" :loading="loading" @click.prevent="inserirColaboracao">
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
    <ModalConfirmAction
      :visible="showInsertConfirmDialog"
      title="Inserir colaboração"
      message="Deseja inserir essa colaboração?"
      confirm-text="Inserir"
      confirm-color="primary"
      @confirm="confirmInserirColaboracao"
      @cancel="showInsertConfirmDialog = false"
    />
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import FakeAvatar from "@/assets/fake-avatar.svg";
import {
  monthNameToNumberObject,
  detectDataLanguage,
  getDateValues,
} from "@/utils/dateUtils";

export default {
  components: {
    FakeAvatar,
    ModalConfirmAction: () => import("@/components/Modal/ModalConfirmAction.vue"),
  },
  data() {
    return {
      moderarColaboracao: true,
      showInsertConfirmDialog: false,
      selectedMidia: false,
      selectedAvatar: false,
      dialog: false,
      dsc_nome_colaborador: "",
      dsc_conta_colaborador: "",
      dsc_colaborador_phone: "",
      dsc_complemento: "",
      dsc_data_colaboracao: "",
      dsc_texto_colaboracao: "",
      flg_sem_avatar: true,
      url_avatar: "",
      avatar_file: null,
      url_image_or_video: null,
      image_or_video_file: null,
      image_or_video_type: "",
      loading: false,
      isColaboradorVerificado: false,
      media_types: [
        "video/mp4",
        "video/ogg",
        "video/webm",
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/jpg",
        "image/tiff",
        "audio/ogg",
        "audio/mpeg",
        "audio/wav",
      ],
      redes_sociais: [
        "Socialcam",
        "Twitter",
        "Whatsapp",
        "Threads",
        "TikTok",
        "Instagram",
        "Youtube",
      ],
      dsc_fonte_colaboracao: "Twitter",
      colunaModerada: null,
      colunas: [],
      phoneRules: {
        counter: (value) => value.length <= 13 || "Máximo 13 digitos",
      },
    };
  },
  props: {
    cod_producao: Number,
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
  },
  mounted() {
    this.getColunasProducao();
    this.$nextTick(() => {
      this.updateScrollbarSize();
    });
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas: "colaboracoes_aprovadas/getColaboracoesAprovadas",
      getColaboracoesModeradas: "colaboracoes_moderadas/getColaboracoesModeradas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
    }),

    updateScrollbarSize() {
      this.$nextTick(() => {
        const textarea = this.$refs.textareaRef?.$el?.querySelector("textarea");
        if (textarea) {
          const scrollHeight = textarea.scrollHeight;
          const clientHeight = textarea.clientHeight;

          // Calculate scroll-ratio-higher values = smaller thumb
          const scrollRatio = Math.max(1, Math.ceil(scrollHeight / clientHeight));

          // Calculate thumb height based on a content ratio
          const thumbHeight = Math.max(
            15,
            Math.min(50, (clientHeight / scrollRatio) * 1.5)
          );

          // Create or update dynamic styles
          let styleElement = document.getElementById(
            "dynamic-scrollbar-styles-colaboracao"
          );
          if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.id = "dynamic-scrollbar-styles-colaboracao";
            document.head.appendChild(styleElement);
          }

          styleElement.textContent = `
            .textoColaboracao .v-textarea textarea::-webkit-scrollbar-thumb {
              min-height: ${Math.max(10, thumbHeight)}px !important;
              max-height: ${Math.max(15, thumbHeight + 5)}px !important;
              height: ${thumbHeight}px !important;
            }
          `;
        }
      });
    },

    async getColunasProducao() {
      await apiClient
        .get(
          `listarColunasPorProducao/${this.$store.state.producoes.selectedProducao.cod_producao}?flg_ativo=true`
        )
        .then((response) => {
          this.colunas = response.data.colunas;
          this.colunaModerada = this.colunas[0];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    close() {
      this.$emit("close");
      this.dialog = false;
      this.clearFormData();
    },
    openChooseFileDialog() {
      const chooseMidiaElement = document.getElementsByClassName("chooseMidia");
      const vFIleInputElement = document.getElementById("uploadAvatar");
      chooseMidiaElement.onclick = function () {
        vFIleInputElement.click;
      };
    },
    onClick(e) {
      if (e.target.checked === true) {
        const elements = document.getElementsByClassName("imgCheckBox");
        for (let i = 0; i <= elements.length - 1; i++) {
          if (elements[i].id !== e.target.id) {
            elements[i].checked = false;
          }
        }
      }
    },
    triggerAvatarUpload() {
      if (this.flg_sem_avatar) {
        this.$refs.avatarInput?.click();
      }
    },
    onAvatarInputChange(event) {
      const file = event.target.files?.[0];
      if (file) {
        this.avatar_file = file;
        this.url_avatar = URL.createObjectURL(file);
        this.selectedAvatar = true;
        this.flg_sem_avatar = false;
      }
    },
    onFileSelected(event) {
      const file = event.target.files?.[0];
      if (file) {
        this.onChangeImageOrVideo(file);
      }
      event.target.value = '';
    },
    onChangeImageOrVideo(e) {
      this.image_or_video_file = e;
      this.url_image_or_video = URL.createObjectURL(this.image_or_video_file);
      const type = this.image_or_video_file.type.split("/");
      this.image_or_video_type = type[0];
      e = null;
      if (this.image_or_video_file) {
        this.selectedMidia = true;
      }
    },
    convertTwitterDateToDatetime(twitter_date) {
      /*
      String date example: "12:07 PM · 30 de out de 2023"
      STEPS:
        1. Split the string date between the hour and date of publication
        2. Get the hour and date and format them properly
        3. Concat the values
        3. Parse the concatenated value into a timestamp ISO value
        4. Use JavaScript Date to get the string of the date
      */

      const [rawHour, date] = twitter_date.split("·");
      const dateLanguage = detectDataLanguage(date.trim());

      const [hour, period] = rawHour.split(" ");
      const [day, month, year] = getDateValues(date, dateLanguage);

      const formatedDay = Number(day) < 10 ? `0${day}` : day;
      const parsed_month = monthNameToNumberObject[month];
      const [hours, minutes] = hour.split(":");
      const formated_hour =
        hours < 10 && hours > 0 && !String(hours).startsWith("0") ? `0${hours}` : hours;
      const am_pm_hour =
        Number(formated_hour) < 12 && period === "PM"
          ? `${Number(formated_hour) + 12}:${minutes}`
          : `${formated_hour}:${minutes}`;

      const dateObject = new Date(
        `${year}-${parsed_month}-${formatedDay}T${am_pm_hour}:00`
      );
      return dateObject;
    },
    clearFormData() {
      this.avatar_file = null;
      this.flg_sem_avatar = true;
      this.dsc_nome_colaborador = "";
      this.dsc_texto_colaboracao = "";
      this.selectedAvatar = null;
      this.selectedMidia = null;
      this.url_avatar = null;
      this.url_image_or_video = null;
      this.image_or_video_file = null;
      this.image_or_video_type = null;
      this.colunaModerada = this.colunas[0];
      this.dsc_fonte_colaboracao = "Twitter";
      this.dsc_conta_colaborador = "";
      this.dsc_complemento = "";
      this.dsc_data_colaboracao = "";
      this.isColaboradorVerificado = false;
      this.dsc_colaborador_phone = "";
      this.moderarColaboracao = true;

      // Reset scrollbar styles after clearing
      this.$nextTick(() => {
        this.updateScrollbarSize();
      });
    },
    async getBucketImages(fileName, subpasta) {
      try {
        const response = await apiClient.get(
          `/getBucketImages?fileName=${fileName}&subpasta=${subpasta}`
        );

        if (response.status === 200) {
          return response.data.url;
        }
      } catch (error) {
        return error;
      }
    },
    async inserirColaboracao() {
      if (!this.dsc_fonte_colaboracao) {
        this.$toast.error("Informe a rede social da colaboração");
        return;
      }

      if (this.dsc_nome_colaborador.trim() === "") {
        this.$toast.error("Digite o nome do colaborador.");
        return;
      }

      if (this.dsc_texto_colaboracao.trim() === "" && !this.image_or_video_file) {
        this.$toast.error("Digite o texto da colaboração.");
        return;
      }

      if (!this.flg_sem_avatar && this.avatar_file === null) {
        this.$toast.error("Selecione um avatar.");
        return;
      }

      if (this.moderarColaboracao && !this.colunaModerada) {
        this.$toast.error("Selecione uma coluna para moderar a colaboração.");
        return;
      }

      if (
        this.image_or_video_file !== null &&
        !this.media_types.includes(this.image_or_video_file.type)
      ) {
        this.$toast.error("Os arquivos suportados para vídeos são: .mp4, .ogg, .webm");
        this.image_or_video_file = null;
        return;
      }

      this.showInsertConfirmDialog = true;
    },
    async confirmInserirColaboracao() {
      this.showInsertConfirmDialog = false;
      try {
        this.loading = true;
        const flag = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false;
        const flg_exibida =
          JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false;
        const dat_colaboracao = new Date();
        const miliseconds = dat_colaboracao.getMilliseconds();
        const dat_colaboracao_formatada = dat_colaboracao
          .toLocaleString("pt-BR", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
          })
          .replaceAll("/", "")
          .replaceAll(":", "")
          .replaceAll(" ", "");

        const id_colaboracao = String(this.cod_producao)
          .concat("-", dat_colaboracao_formatada)
          .concat("-", miliseconds)
          .concat("-", Math.floor(Math.random() * 1000).toString());

        let url_avatar_colaborador;
        let url_midia_colaboracao;
        let dsc_arquivo_gcp_avatar = null;
        let dsc_arquivo_gcp_imagem_or_video = null;
        let formDataModerada;

        if (this.avatar_file !== null) {
          const file_type = this.avatar_file.type.split("/");
          dsc_arquivo_gcp_avatar = id_colaboracao.concat(".", file_type[1]);
        }

        if (!this.flg_sem_avatar) {
          await apiClient
            .post(
              "/uploadFileToGCP",
              {
                file: this.avatar_file,
                subpasta: "avatares",
                fileName: dsc_arquivo_gcp_avatar,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .catch((error) => {
              console.error("ERRO upload avatar gcp: ", error);
              this.loading = false;
            });

          url_avatar_colaborador = await this.getBucketImages(
            dsc_arquivo_gcp_avatar,
            "avatares"
          );
        }

        const formData = {
          id_colaboracao,
          cod_producao: this.cod_producao,
          dsc_fonte_colaboracao: this.dsc_fonte_colaboracao.toLowerCase(),
          dsc_nome_colaborador: this.dsc_nome_colaborador,
          flg_colaborador_verificado: this.isColaboradorVerificado,
          dsc_colaborador_user: this.dsc_conta_colaborador,
          dsc_texto_colaboracao: this.dsc_texto_colaboracao,
          dsc_complemento: this.dsc_complemento,
          url_avatar_colaborador: !this.flg_sem_avatar ? url_avatar_colaborador : "",
          flg_sem_avatar: this.flg_sem_avatar === true ? "S" : "N",
          dat_colaboracao,
          dsc_arquivo_gcp: dsc_arquivo_gcp_avatar
            ? dsc_arquivo_gcp_avatar
            : dsc_arquivo_gcp_imagem_or_video
            ? dsc_arquivo_gcp_imagem_or_video
            : null,
          dsc_colaborador_phone: this.dsc_colaborador_phone,
        };
        if (this.moderarColaboracao) {
          formDataModerada = {
            id_colaboracao: id_colaboracao,
            cod_producao: this.cod_producao,
            num_coluna_telao: this.colunaModerada.num_coluna_telao,
            dat_moderacao: new Date(),
            dsc_login_moderacao: this.$store.state.users.user.dsc_login_usuario,
          };
        }

        if (this.image_or_video_file !== null) {
          const file_type = this.image_or_video_file.type.split("/");
          dsc_arquivo_gcp_imagem_or_video = id_colaboracao.concat(".", file_type[1]);
          formData.dsc_arquivo_gcp = !formData.dsc_arquivo_gcp
            ? dsc_arquivo_gcp_imagem_or_video
            : formData.dsc_arquivo_gcp;

          await apiClient
            .post(
              "/uploadFileToGCP",
              {
                file: this.image_or_video_file,
                subpasta: "colaboracoes",
                fileName: dsc_arquivo_gcp_imagem_or_video,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(async () => {
              await apiClient.post(`/inserirColaboracao`, formData);
              if (this.moderarColaboracao) {
                await apiClient
                  .post("/inserirColaboracaoModerada", formDataModerada)
                  .catch((error) => {
                    console.error("Erro ao moderar colaboração avulsa diretamente.", error);
                  });
              }
            })
            .catch((error) => {
              console.error("ERRO upload midia gcp: ", error);
              this.loading = false;
            });

          url_midia_colaboracao = await this.getBucketImages(
            dsc_arquivo_gcp_imagem_or_video,
            "colaboracoes"
          );

          let url_midia_thumbnail;

          if (file_type[0].includes("video")) {
            url_midia_thumbnail = await this.getBucketImages(
              id_colaboracao.concat(".", "png"),
              "colaboracoes/thumbnail"
            );
          } else {
            url_midia_thumbnail = url_midia_colaboracao;
          }

          await apiClient.post("/inserirImagemColaboracao", {
            cod_producao: this.cod_producao,
            id_colaboracao,
            id_imagem: id_colaboracao,
            dsc_tipo_midia_colaboracao: file_type[0],
            url_midia_colaboracao,
            url_midia_thumbnail,
            flg_selecionada: "S",
            dsc_arquivo_gcp: dsc_arquivo_gcp_imagem_or_video,
            dsc_extencao_midia: file_type[1],
          });
        } else {
          await apiClient.post(`/inserirColaboracao`, formData);
          if (this.moderarColaboracao) {
            await apiClient
              .post("/inserirColaboracaoModerada", formDataModerada)
              .catch((error) => {
                console.error("Erro ao moderar colaboração avulsa diretamente.", error);
              });
          }
        }

        await this.getColaboracoesAprovadas({
          page: 1,
          size: 5,
          cod_producao: this.cod_producao,
          flg_favorita: flag,
          flg_exibida,
          cod_pasta: this.cod_pasta,
        });
        if (this.moderarColaboracao) {
          await this.getColaboracoesModeradas({
            page: 1,
            size: 5,
            cod_producao: this.cod_producao,
            num_coluna_telao: this.colunaModerada.num_coluna_telao,
            filtro_texto_moderada: "",
          });
        }

        this.setCopyColaboracoesRecebidas(
          this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
        );
        this.$toast.success("Colaboração inserida com sucesso.");
        this.clearFormData();
      } catch (error) {
        this.loading = false;
        console.error(error);
        const msg = error.response?.data?.error || "Erro ao inserir colaboração";
        this.$toast.error(msg);
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    limparInputImagem() {
      this.url_image_or_video = 1;
      this.image_or_video_file = null;
      this.image_or_video_type = null;
      this.selectedMidia = false;
    },
    limparAvatarImagem() {
      this.avatar_file = null;
      this.url_avatar = null;
      this.flg_sem_avatar = true;
    },
  },
  watch: {
    dsc_texto_colaboracao: {
      handler() {
        this.updateScrollbarSize();
      },
    },
    "$store.state.producoes.selectedProducao": async function () {
      await this.getColunasProducao();
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal structure (sc-modal__*) comes from _modal.scss. This block only
// carries component-specific bits: the "Nova colaboração" activator and the
// avatar / media / toggle widgets unique to this form.
.inserirColabButton {
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  padding: 0 12px !important;

  &__label {
    color: var(--v-primary-base);
    font-size: 0.8rem;
    font-weight: 700;
  }

  &:hover {
    background: rgba(var(--sc-color-primary-rgb),0.08) !important;
  }
}

.char-counter {
  font-size: 0.75rem;
  color: var(--v-text_secondary-base);
  opacity: 0.6;
  text-align: right;
}

/* Avatar row */
.avatar-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.avatar-wrapper {
  position: relative;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  cursor: pointer;
}

.avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.avatar-remove-btn {
  position: absolute !important;
  top: -4px;
  right: -4px;
  background: rgba(var(--sc-color-error-rgb),0.9) !important;
  color: white !important;

  .v-icon { color: white !important; }
}

.avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
}

.fake-avatar-svg {
  width: 48px;
  height: 48px;
}

.avatar-wrapper:hover .avatar-placeholder {
  border-color: var(--v-primary-base);
  background: rgba(var(--sc-color-primary-rgb),0.06);
}

.avatar-edit-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Twitter warning */
.twitter-warning {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: rgba(var(--sc-color-error-rgb),0.08);
  border: 1px solid rgba(var(--sc-color-error-rgb),0.2);
  border-radius: var(--sc-radius-md);

  span {
    font-size: 0.8rem;
    color: var(--v-error-base);
  }
}

/* Social account row */
.social-account-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;

  ::v-deep .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 6px;
  }
}

/* Moderar toggle */
.moderar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: var(--sc-surface-tint-subtle);
  border: 1px solid var(--sc-border-subtle);
  border-radius: var(--sc-radius-md);
}

.moderar-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v-text_primary-base);
}

::v-deep .v-input--switch { margin: 0; padding: 0; }

/* Media area */
.media-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 90px;
  border: 1px dashed var(--sc-border-hover);
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  position: relative;

  &:hover {
    border-color: var(--v-primary-base);
    background: rgba(var(--sc-color-primary-rgb),0.04);

    .media-icon { color: var(--v-primary-base) !important; }
  }
}

.media-icon {
  font-size: 28px !important;
  opacity: 0.5;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
}

.media-input-overlay {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 2;

  ::v-deep .v-input__control {
    cursor: pointer !important;
    height: 100% !important;
    min-height: 100% !important;
  }

  ::v-deep .v-input__slot {
    cursor: pointer !important;
    height: 100% !important;
    min-height: 100% !important;

    &::before, &::after {
      display: none !important;
    }
  }

  ::v-deep .v-file-input__text {
    cursor: pointer !important;
    height: 100% !important;
  }

  ::v-deep .v-text-field__details {
    display: none !important;
  }
}

.media-hint {
  font-size: 0.75rem;
  color: var(--v-text_secondary-base);
  opacity: 0.6;
  margin-top: 4px;
}

.media-preview {
  position: relative;
  margin-top: 8px;
}

.media-remove-btn {
  position: absolute !important;
  top: 4px;
  right: 4px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(4px);

  .v-icon { color: white !important; }

  &:hover {
    background: rgba(var(--sc-color-error-rgb),0.8) !important;
  }
}

.media-img {
  max-width: 200px;
  max-height: 150px;
  border-radius: var(--sc-radius-md);
  object-fit: cover;
}

.audio-file {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: var(--sc-surface-tint);
  border: 1px solid var(--sc-border-emphasis);
  border-radius: var(--sc-radius-md);
  width: 100%;

  span {
    font-size: var(--sc-text-base);
    font-weight: 500;
    color: var(--v-text_primary-base);
  }
}

</style>
